import React, { useState, useCallback, useRef, useMemo } from "react";
import { Popover, PopoverBody } from "reactstrap";
import shortid from "shortid";

export const usePopover = ({ target: targetProp } = {}) => {
  const [isOpen, setIsOpen] = useState();
  const ref = useRef();
  const target = useMemo(() => targetProp || "id-" + shortid(), []);

  function toggle() {
    setIsOpen(!isOpen);
  }

  ref.current = { isOpen, toggle, target };

  const renderPopover = useCallback(
    (props) => {
      if (!ref.current.isOpen) return null;
      return <Popover {...ref.current} {...props} />;
    },
    [ref]
  );

  return {
    isOpen,
    setIsOpen,
    toggle,
    target,
    Popover: renderPopover,
    PopoverBody,
  };
};

export default usePopover;
